import axios from "axios";
import constants from "../../utils/constants";

export const createInteliposChargeRequest = createInteliposChargeRequest => {
  return axios.post(
    `${constants.BASE_URL}/api/mit/intelipos/create-charge-request`,
    createInteliposChargeRequest,
    {
      withCredentials: true
    }
  );
};

export const getInteliposChargeResponseByReference = (referencia: string) => {
  return axios.get(
    `${constants.BASE_URL}/api/mit/intelipos/get-charge-by-reference`,
    {
      withCredentials: true,
      params: { referencia }
    }
  );
};
